import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';

import { useStyles } from './styles';

import { ReactComponent as IconErroPrimeiroAcesso } from '../../assets/icons/iconErroPrimeiroAcesso.svg';
import ROUTES_NAME from '../../consts/routes-name';
import { AutenticationActions } from '../../store/ducks/autentication';
import ReactGTM from '../../utils/gtm';
import CustomBottomSheet from '../CustomBottomSheet/index';
import CustomButton from '../CustomButton/CustomButton';
import CustomLoading from '../CustomLoading/CustomLoading';
import CustomModal from '../CustomModal/CustomModal';

const { setAutenticateMessage, setErrorDescription } = AutenticationActions;

const getCadastroUrl = () => {
  const ambiente = process.env.REACT_APP_AMBIENTE;

  switch (ambiente) {
    case 'DEV':
      return 'https://avisoweb.dev-cld.brasilseg.com.br/cadastro';
    case 'HML':
      return 'https://avisoweb.hml-cld.brasilseg.com.br/cadastro';
    case 'PRD':
      return 'https://avisoweb.cld.brasilseg.com.br/cadastro';
    default:
      return 'https://avisoweb.cld.brasilseg.com.br/cadastro';
  }
};

export default function ModalErroPrimeiroAcesso() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'));

  const store = useSelector((state) => ({
    autenticacao: state.autenticacao,
  }));

  const [showModal, setShowModal] = useState(false);

  const {
    autenticacao: { message, errorDescription, loading, redirectCadastro },
  } = store;

  const handleCloseModal = (redirect = true) => {
    //* * Google Analytics */
    ReactGTM.event({
      event: 'modal',
      action: 'open',
      name: 'erro-primeiro-acesso',
    });
    setShowModal(false);

    if (message) {
      dispatch(setAutenticateMessage(null));
      dispatch(setErrorDescription(null));
    }
    if (redirect) {
      navigate(ROUTES_NAME.HOME);
    }
  };
  const subTitle = redirectCadastro
    ? 'Você será redirecionado para um formulário de cadastro. Clique em Continuar para preenchê-lo.'
    : errorDescription;

  const handleContinuar = () => {
    const url = getCadastroUrl();
    window.location.href = url;
  };

  useEffect(() => {
    const hasErro = Boolean(message);
    //* * Google Analytics */
    ReactGTM.event({
      event: 'modal',
      action: 'open',
      name: 'erro-primeiro-acesso',
    });
    setShowModal(hasErro);
  }, [message]);

  return (
    <>
      {loading && <CustomLoading open={loading} />}
      {isMobile ? (
        <CustomBottomSheet
          open={showModal}
          handleClose={() => handleCloseModal(false)}
          title={message}
          subTitle={subTitle}
          body={
            <Grid container alignItems="center" direction="column">
              {redirectCadastro ? (
                <Grid item xs={12}>
                  <CustomButton
                    fullWidth
                    content="CONTINUAR"
                    onClickCallBack={handleContinuar}
                  />
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <CustomButton
                    fullWidth
                    content="VOLTAR PARA LOGIN"
                    onClickCallBack={handleCloseModal}
                  />
                </Grid>
              )}
            </Grid>
          }
        />
      ) : (
        <CustomModal
          open={showModal}
          title={message}
          icon={<IconErroPrimeiroAcesso />}
          className={classes.modal}
          body={
            <Grid container alignItems="center" direction="column">
              {subTitle && (
                <Typography className={classes.message}>{subTitle}</Typography>
              )}
            </Grid>
          }
          actions={
            <Grid container spacing={2} justifyContent="center">
              {redirectCadastro ? (
                <Grid item>
                  <CustomButton
                    content="CONTINUAR"
                    onClickCallBack={handleContinuar}
                  />
                </Grid>
              ) : (
                <Grid item>
                  <CustomButton
                    content="VOLTAR PARA LOGIN"
                    onClickCallBack={handleCloseModal}
                  />
                </Grid>
              )}
            </Grid>
          }
          handleClose={() => handleCloseModal(false)}
        />
      )}
    </>
  );
}
